export default __webpack_public_path__ + "static/media/Reddened Lacerator.6b581e96.jpg";